import { ICountry, ICountryData } from '../country';
import {
  IEmployeeWorkgroup,
  IEmployeeWorkgroupData
} from '../employee-workgroup';
import { IHrDepartment, IHrDepartmentData } from '../hr-department';
// API Data

export interface IEmployeeData {
  id?: number;
  first_name: string;
  last_name: string;
  title?: string;
  type: number;
  subtype?: number;
  employee_number?: string | null;
  is_active?: boolean;
  ooo_info?: null | IOOOInfoData;
  supervisor?: IEmployeeData | null | number;
  location?: ICountryData | null | number;
  user?: null | number;
  hr_department?: IHrDepartmentData | null | number;
  workgroup?: IEmployeeWorkgroupData | null | number;
  hire_date?: string;
  end_date?: string;
  phone?: string;
}

export interface IEmployeeFieldErrorData {
  first_name?: string[];
  last_name?: string[];
  employee_number?: string[];
  is_active?: string[];
  type?: string[];
  subtype?: string[];
  hire_date?: string[];
  end_date?: string[];
  title?: string[];
  supervisor?: string[];
  user?: string[];
  location?: string[];
  hr_department?: string[];
  workgroup?: string[];
  phone?: string[];
}

export interface IWorkDayData {
  value: number;
  name: string;
}

export interface IOOOInfoData {
  alternates?: IEmployeeData[];
}

export interface IScheduleWorkDayData {
  workday: number;
}
export interface IScheduleWorkDay extends IScheduleWorkDayData {
  validate(): boolean;
}

export interface IEmployeeWorkScheduleData {
  employee?: number;
  scheduled_days?: (IScheduleWorkDayData | number)[];
  workday_hours?: number;
}

export interface IEmployeeWorkSchedule extends IEmployeeWorkScheduleData {
  scheduled_days?: (IScheduleWorkDay | number)[];
  validate(): boolean;

  /**
   * @property
   * getter for rruleScheduledDays
   */
  rruleScheduledDays: number[];
}

export interface IOOOInfo extends IOOOInfoData {
  validate(): boolean;
}

export interface IScheduleWorkDayFieldErrorData {
  workday: string[];
}
export interface IScheduleWorkDayFieldError
  extends IScheduleWorkDayFieldErrorData {
  clearErrors(): void;
}

export interface IEmployeeWorkScheduleFieldErrorData {
  employee?: string[];
  scheduled_days?: IScheduleWorkDayFieldErrorData[];
  workday_hours?: string[];
}

export interface IEmployeeWorkScheduleFieldError
  extends IEmployeeWorkScheduleFieldErrorData {
  scheduled_days: IScheduleWorkDayFieldError[];

  clearErrors(): void;
}

export interface IEmployee extends IEmployeeData {
  supervisor?: IEmployee | null | number;
  location?: ICountry | null | number;
  hr_department?: IHrDepartment | null | number;
  workgroup?: IEmployeeWorkgroup | null | number;
  phone: string;

  validate(): boolean;

  /**
   * @property
   * getter for fullName
   */
  fullName: string;
  /**
   * @property
   * getter for fullName
   */
  intitials: string;
  /**
   * @property
   * getter for employee type
   */
  isHourly: boolean;
  /**
   * @property
   * getter for toString()
   */
  toString(): string;
  /**
   * @property
   * getter for subtype string representation
   */
  subtypeToString(): string;
}

export interface IEmployeeTree extends IEmployeeData {
  children: IEmployeeTree[];
  validate(): boolean;
}

export interface IEmployeeFieldError extends IEmployeeFieldErrorData {
  clearErrors(): void;
}

export enum EmployeeType {
  Salary,
  Hourly
}
export enum EmployeeHourlySubType {
  DayShift,
  AfternoonShift
}
export enum EmployeeSalarySubType {
  Salary,
  SalaryContract,
  TempAgency,
  CoOp,
  PartTime
}

export enum DayType {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday
}

export const DEFAULT_WORKDAY_HOURS = 8;
